<template>
    <el-button type="warning" plain  icon="el-icon-download" v-on:click="clickEvent()">{{btnCon}}</el-button>
</template>
  
  <script>
  
  export default {
    name: 'export-button',
    props: {
      btnCon: {
            type: String,
            default: () => {
                return "导出"
            }
        },
    },
    data () {
      return {
      }
    },
    mounted () {
    },
    methods: {
        clickEvent(){
            this.$emit('select-type',1);
        }
    }
  }
  </script>
  
  <style lang="scss">
  </style>
  


// WEBPACK FOOTER //
// ExportButton.vue?3be311a7